export default function Auth(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}